import React, { createContext, useContext } from "react";

import { workerStore } from "./worker-store";

type FileSystemWorkerContextType = {
  workerStore: typeof workerStore;
};

const FileSystemWorkerContext: React.Context<FileSystemWorkerContextType | null> =
  import.meta.hot?.data.fileSystemWorkerContext ?? createContext<FileSystemWorkerContextType | null>(null);

if (import.meta.hot) {
  import.meta.hot.data.fileSystemWorkerContext = FileSystemWorkerContext;
}

export const useFileSystemWorker = () => {
  const context = useContext(FileSystemWorkerContext);
  if (!context) {
    throw new Error("useFileSystemWorker must be used within a FileSystemWorkerProvider");
  }
  return context;
};

export const FileSystemWorkerProvider = ({ children }: { children: React.ReactNode }) => {
  return <FileSystemWorkerContext.Provider value={{ workerStore }}>{children}</FileSystemWorkerContext.Provider>;
};
